import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/user/login'
import Register from '../views/user/register'
import Explain from '../views/explain/explain'
import ExplainDetail from '../views/explain/explainDetail/index'
import ShoppingCart from '../views/shoppingCart/index'
// import DrugCategory from '../views/drugCategory/drugCategory'
import Custom from '../views/custom/custom'
import GoodDetail from '../views/goodDetail/goodDetail'
// import Order from '../views/order/order.vue'
// import Logistics from '../views/userCenter/order/logistics/logistics'
import NotFound from '../views/404/notFound'
import Download from '../views/goodDetail/goodDetailWindow'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },{
    path: '/login',
    name: 'login',
    component: Login
  },{
    path: '/register',
    name: 'register',
    component: Register
  },{
    path: '/explain',
    name: 'explain',
    component: Explain,
    children: [{
      path: '/explain/detail/:detailId',
      name: 'explainDetail',
      meta: {reflash: false},
      component: ExplainDetail
    }]
  },{
    path: '/shoppingCart',
    name: 'shoppingCart',
    component: ShoppingCart,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },{
    path: '/custom/:customId',
    name: 'custom',
    component: Custom
  },
  {
    path: '/goodDetail/:goodsId',
    name: 'goodDetail',
    component: GoodDetail
  },
  {
    path: '/drugCategory',
    name: 'drugCategory',
    component: () => import('@/views' + '/drugCategory/drugCategory' + '.vue'),
    // component: DrugCategory,
  },{
    path: '/userCenter/logistics',
    name: 'logistics',
    // component: Logistics
    component: () => import('@/views' + '/userCenter/order/logistics/logistics' + '.vue'),
  },
  {
    path: '/order/order',
    name: 'order',
    // component: Order
    component: () => import('@/views' + '/order/order' + '.vue'),
  },
  {
    path: '/forgetPasswordNew',
    name: 'forgetPasswordNew',
    component: () => import('@/views' + '/user/forgetPasswordNew' + '.vue'),
  },
  {
    path: '/userCenter/index',
    name: '用户中心',
    component: () => import('@/views' + '/userCenter/index' + '.vue'),
    children:[{
      path: '/userCenter/userInfo',
      name: '基本信息',
      component: () => import('@/views' + '/userCenter/userInfo/index' + '.vue'),
    },{
      path: '/userCenter/securitySetting',
      name: '安全设置',
      component: () => import('@/views' + '/userCenter/securitySetting/index' + '.vue'),
    },{
      path: '/userCenter/address',
      name: '收货地址',
      component: () => import('@/views' + '/userCenter/address/index' + '.vue'),
    },{
      path: '/userCenter/enterpriseCertification',
      name: '企业认证',
      component: () => import('@/views' + '/userCenter/enterpriseCertification/enterpriseCertification' + '.vue'),
    },{
      path: '/userCenter/letter',
      name: '站内信',
      component: () => import('@/views' + '/userCenter/letter/letter' + '.vue'),
    }]
  },{
    path: '/userCenter/index',
    name: '我的交易',
    component: () => import('@/views' + '/userCenter/index' + '.vue'),
    children:[{
      path: '/userCenter/order',
      name: '我的订单',
      component: () => import('@/views' + '/userCenter/order/index' + '.vue'),
    },{
      path: '/userCenter/collection',
      name: '我的收藏',
      component: () => import('@/views' + '/userCenter/collection/index' + '.vue'),
    },{
      path: '/userCenter/score',
      name: '积分中心',
      component: () => import('@/views' + '/userCenter/score/score' + '.vue'),
    },{
      path: '/userCenter/footprint',
      name: '足迹',
      component: () => import('@/views' + '/userCenter/footprint/footprint' + '.vue'),
    }]
  },{
    path: '/download',
    name: '下载',
    component: Download
  },
  {
    path: '*',
    name: 'notFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
